export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7672.0904f20f.jpg";